var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "settingCon" },
    [
      _c(
        "van-cell-group",
        [
          _c("van-cell", {
            staticClass: "barlist",
            attrs: {
              title: "昵称",
              "is-link": "",
              value: "修改昵称",
              center: "",
              "value-class": "valCal"
            },
            on: {
              click: function($event) {
                return _vm.gotoPath("/updatename")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        [
          _c("van-cell", {
            staticClass: "barlist",
            attrs: {
              title: "密码",
              "is-link": "",
              value: "修改密码",
              center: "",
              "value-class": "valCal"
            },
            on: {
              click: function($event) {
                return _vm.gotoPath("/updatepassword")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        [
          _c("van-cell", {
            staticClass: "barlist",
            attrs: {
              title: "手机号",
              "is-link": "",
              value: "修改手机号",
              center: "",
              "value-class": "valCal"
            },
            on: {
              click: function($event) {
                return _vm.gotoPath("/updatephone")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-col",
        {
          staticClass: "barBtn",
          attrs: { span: "24", type: "flex", justify: "space-between" }
        },
        [
          _c(
            "van-button",
            {
              staticClass: "btn",
              attrs: { round: "", type: "danger", size: "large" },
              on: {
                click: function($event) {
                  return _vm.gotoPath("/login")
                }
              }
            },
            [_vm._v("退出当前账号")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0890b18a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0890b18a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Settings/Settings.vue
// module id = null
// module chunks = 